
import { collection, doc, Firestore } from "firebase/firestore";

export const getLocationVersionsRef = (db: Firestore) => collection(db, "campLocationVersions");
export const getLocationVersionRef = (db: Firestore, versionId: string) => 
  doc(db, "campLocationVersions", versionId);
